"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = decodeDescriptor;

var _protobufjs = _interopRequireDefault(require("protobufjs"));

var _descriptor = _interopRequireDefault(require("protobufjs/ext/descriptor"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * decode descriptor.proto into a Protobuf.js Type instance
 * @param protoDescriptor - encoded file descriptor
 * @param {Boolean} [forWeb=false] - return a serialized object with fields, types, an enums to make it easier for UI
 * @returns {Object}
 */


function decodeDescriptor(protoDescriptor) {
  var forWeb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (!Buffer.isBuffer(protoDescriptor)) {
    var uint8 = new Uint8Array();

    var len = _protobufjs.default.util.base64.decode(protoDescriptor, uint8, 0);

    uint8 = new Uint8Array(len);

    _protobufjs.default.util.base64.decode(protoDescriptor, uint8, 0);

    protoDescriptor = uint8;
  }

  var decodedDescriptor = _descriptor.default.FileDescriptorSet.decode(protoDescriptor);

  var root = _protobufjs.default.Root.fromDescriptor(decodedDescriptor);

  var type = root.lookupType('P'); // convert types in fieldsArray (takes care of everything NOT ENUMS)
  // convert .oipProto.Txid to Txid

  var _iterator = _createForOfIteratorHelper(type.fieldsArray),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _field2 = _step.value;

      if (_field2.type === '.oipProto.Txid') {
        _field2.type = formatTxidType(_field2.type);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  var webFmt;

  if (forWeb) {
    webFmt = {
      enums: {},
      fields: {}
    };
    var nestedArray = type.nestedArray;
    var fieldArray = type.fieldsArray; //creates the enum object in webFmt

    var _iterator2 = _createForOfIteratorHelper(nestedArray),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var field = _step2.value;

        if (field.name !== 'Txid') {
          webFmt.enums[field.name] = {
            values: field.values,
            //passes enum values 
            rule: field.rule
          };
        }
      } //creates the field object in webFmt

    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }

    var _iterator3 = _createForOfIteratorHelper(fieldArray),
        _step3;

    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var _field = _step3.value;

        // checks type
        // if type matches enum name
        // add enumRefname to the field object
        switch (_field.type) {
          case 'string':
          case 'bool':
          case 'bytes':
          case 'double':
          case 'float':
          case 'OipRef':
          case 'int32':
          case 'int64':
          case 'uint32':
          case 'uint64':
          case 'sint32':
          case 'sint64':
          case 'fixed32':
          case 'fixed64':
          case 'sfixed32':
          case 'sfixed64':
            webFmt.fields[_field.name] = {
              type: _field.type,
              id: _field.id,
              repeated: _field.repeated,
              extend: _field.extend
            };
            break;

          case 'Txid':
            webFmt.fields[_field.name] = {
              type: 'OipRef',
              id: _field.id,
              repeated: _field.repeated,
              extend: _field.extend
            };
            break;

          default:
            webFmt.fields[_field.name] = {
              type: _field.type,
              id: _field.id,
              repeated: _field.repeated,
              extend: _field.extend,
              enumRefName: type.lookup(".oipProto.templates.P.".concat(_field.type)).name
            };
        }
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  }

  return {
    type: type,
    webFmt: webFmt
  };
}

var formatTxidType = function formatTxidType(typePath) {
  return typePath.split('.')[2]; // [ '', 'oipProto', 'Txid' ]
};